import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import * as types from '../../../../constants/actionTypes';
import Drawer from '../../../Common/Drawer/Drawer';
import Notification from '../../../Common/Notification';
import MultiSelectBox from '../../../Common/MultiSelectBox/MultiSelectBox';
import LoadingIndicator from '../../../Common/LoadingIndicator/LoadingIndicator';
import Routes from '../../../../constants/routes';
import { actions as projectLocationActions } from '../../../../actions/projectLocationActions';
import './AddBaselineDrawer.scss';

export class AddBaselineDrawer extends Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			selectedBaselineIds: '',
			isFormValid: true,
			isSaving: false,
		};
	}

	formIsValid = () => {
		return this.state.selectedBaselineIds.length > 0;
	};

	onSaveClick = () => {
		// update isSaving immediately to remove Push button to prevent multiple api calls from double-clicks
		if (this.state.isSaving === false) {
			this.setState({ isSaving: true }, this.save);
		}
	};

	save = async () => {
		if (this.formIsValid()) {
			try {
				const request = {
					locationIds: this.props.selectedProjectLocations.map((m) => m.locationId),
					baselineIds: this.state.selectedBaselineIds.split(','),
					projectKey: this.props.projectKey,
				};

				const response = await this.props.projectLocationActions.addBaseline(request);
				if (response.type === types.ADD_BASELINE_PROJECTLOCATION_SUCCESS) {
					Notification('success', 'Success', 'Tasks pushed down successfully');
					this.props.onComplete();
				} else if (response.type === types.ADD_BASELINE_PROJECTLOCATION_FAILURE) {
					Notification('error', 'An Error Occurred', response.payload.message);
					this.setState({ isSaving: false });
				}
			} catch (error) {
				Notification('error', 'Error', error);
				this.setState({ isSaving: false });
			}
		} else {
			this.setState({ isFormValid: false, isSaving: false });
		}
	};

	onChangeBaseline = (ids) => {
		this.setState({ selectedBaselineIds: ids });
	};

	render() {
		return (
			<div>
				<Drawer
					isWide={false}
					title='Add Baseline'
					onSaveClick={this.state.isSaving ? null : this.onSaveClick}
					saveText='Push'
					isSaveDisabled={this.state.isSaving}
					onCancelClick={this.props.onCancel}>
					<LoadingIndicator isLoading={this.props.isLoading || this.state.isSaving}>
						<form noValidate className={this.state.isFormValid ? '' : 'was-validated'}>
							<MultiSelectBox
								name='baselines'
								label='Baselines to Push'
								idField='id'
								valueField='name'
								options={this.props.baselines}
								selectedValues={this.state.selectedBaselineIds.toString()}
								onChange={this.onChangeBaseline}
								isRequired={true}
								errorMessage='Baseline is required'
								isMulti={true}
							/>
						</form>
						{this.props.baselines && this.props.baselines.length === 0 && (
							<p className='text-danger'>
								There are no additional baselines linked to this project. You can add another baseline to the project in the Project
								Dashboard.
							</p>
						)}
					</LoadingIndicator>
				</Drawer>
			</div>
		);
	}
}

AddBaselineDrawer.propTypes = {
	projectLocationActions: PropTypes.object.isRequired,
	baselines: PropTypes.array.isRequired,
	selectedProjectLocations: PropTypes.array.isRequired,
	projectKey: PropTypes.string.isRequired,
	onComplete: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
	isLoading: PropTypes.bool.isRequired,
};

const mapDispatchToProps = (dispatch) => {
	return {
		projectLocationActions: bindActionCreators(projectLocationActions, dispatch),
	};
};

export default connect(null, mapDispatchToProps)(AddBaselineDrawer);
